// Review answers are scoped by income year and business state.
const taxDeductionHunterYear = (state, year) => {
  const years = state?.taxDeductionHunterByYear;
  const items = years && typeof years === 'object' ? years[String(year)] : null;
  return items && typeof items === 'object' ? items : {};
};
const taxDeductionHunterUpdate = (state, year, id, patch, timestamp) => {
  const yearKey = String(year);
  const years = state.taxDeductionHunterByYear && typeof state.taxDeductionHunterByYear === 'object'
    ? state.taxDeductionHunterByYear : {};
  const items = taxDeductionHunterYear(state, year);
  const previous = items[id] || {};
  const answer = patch.answer === 'yes' || patch.answer === 'no' ? patch.answer : previous.answer;
  if (!answer) return state;
  const done = answer === 'yes' && (patch.done === undefined ? previous.done === true : patch.done === true);
  return { ...state, taxDeductionHunterByYear: { ...years, [yearKey]: {
    ...items, [id]: { answer, done, at: timestamp },
  } } };
};
const taxDeductionHunterUpdateAnswers = (state, year, answers, timestamp) =>
  Object.entries(answers).reduce((next, [id, answer]) =>
    taxDeductionHunterUpdate(next, year, id, { answer }, timestamp), state);
window.PlummeTaxDeductionHunter = { year: taxDeductionHunterYear, update: taxDeductionHunterUpdate, updateAnswers: taxDeductionHunterUpdateAnswers };
